import type { UpcomingCalendarEventResponse } from "@speakai/shared";
import type { ApiHttpClient, RequestOptions } from "../interfaces/api-http-client";

export type CalendarType = "google" | "outlook";

export interface AutoJoinSettings {
  zoom: string;
  googleMeet: string;
  microsoftTeams: string;
  webex: string;
}

export interface CalendarAccount {
  _id?: string;
  calendarId: string;
  calendarName: string;
  calendarType: CalendarType;
  email: string;
  isActive: boolean;
  isDeleted: boolean;
  autoJoin?: AutoJoinSettings;
}

/** One upcoming calendar meeting with a join link, parsed from `GET /integration/calendar/upcoming`. */
export interface UpcomingMeeting extends Pick<UpcomingCalendarEventResponse, "eventId" | "title" | "meetingURL"> {
  startTime: number;
  endTime: number;
  /** The platform's display name, such as "Zoom" or "Google Meet". */
  platformLabel: string;
}

export function isActiveCalendar(calendar: CalendarAccount): boolean {
  return calendar.isActive && !calendar.isDeleted;
}

export function createCalendarApi(http: ApiHttpClient) {
  return {
    async getAccounts(options?: RequestOptions) {
      return http.get<Array<{ calendars: CalendarAccount }>>("/integration/calendar", undefined, options);
    },

    async getUpcoming(range: { from: string; to: string }, options?: RequestOptions) {
      const query = new URLSearchParams(range);
      return http.get<{ events: UpcomingCalendarEventResponse[] }>(`/integration/calendar/upcoming?${query}`, undefined, options);
    },
  };
}
